import { useEffect, useRef, useState } from 'react'

export const defaultFloatOptions = {
  openDelay: 100,
  closeDelay: 100,
}

export interface UseFloatHoverOptions {
  openDelay?: number
  closeDelay?: number
}

interface UseFloatHoverResult {
  show: boolean
  open: () => void
  close: () => void
  delayOpen: () => void
  delayClose: () => void
}

export const useFloatHover = (
  options: UseFloatHoverOptions = defaultFloatOptions,
): UseFloatHoverResult => {
  const [show, setShow] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const open = (): void => {
    if (timer.current !== null) {
      clearTimeout(timer.current)
      timer.current = null
    }
    setShow(true)
  }

  useEffect(() => {
    if (show && timer.current) {
      setShow(false)
    }
  }, [show])

  const delayOpen = (): void => {
    if (timer.current !== null) {
      clearTimeout(timer.current)
      timer.current = null
    }
    setTimeout(() => {
      setShow(true)
    }, options.openDelay ?? defaultFloatOptions.openDelay)
  }

  const close = (): void => {
    setShow(false)
  }

  const delayClose = (): void => {
    timer.current = setTimeout(() => {
      setShow(false)
    }, options.closeDelay ?? defaultFloatOptions.closeDelay)
  }
  return { show, open, close, delayClose, delayOpen }
}
